import { ErrorService } from "services/error-service";
import { Router } from "aurelia-router";
import { Models } from "models/core";
import { LoopTypeService } from "services/loop-type-service";
import { autoinject } from "aurelia-framework";
import { ToastService } from "services/toast-service";
import { EventAggregator } from "aurelia-event-aggregator";

@autoinject
export class LoopTypeNew {
  private looptype: Models.LoopType = new Models.LoopType();

  constructor(
    private loopTypeService: LoopTypeService, 
    private router: Router,
    private toastService: ToastService,
    private errorService: ErrorService,
    private eventAggregator: EventAggregator
  ) {}

  createLoopType() {
    this.loopTypeService
      .post(this.looptype)
      .then(res => {
        this.eventAggregator.publish("loopTypeListReset", 1);
        this.toastService.showSuccess("looptype.created");
        this.router.navigateToRoute("loop-type-detail", { Id: res.Id });
      })
      .catch(err => this.errorService.handleError(err));
  }
}
